"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightStatusBadge = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const FlightStatusBadge = (props) => {
    const { isBookedOut, isDeactivated, flightStatus } = props;
    const className = 'flight-status-badge';
    const itemClassName = `${className}__item`;
    const getBookedOutBadge = () => {
        if (!isBookedOut)
            return null;
        return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(itemClassName, 'bookedOut') },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/FlightStatusBadge:bookedOut', defaultMessage: 'Marked as booked out' })));
    };
    const getStatusBadge = () => {
        if (flightStatus === 'cancelled') {
            return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(itemClassName, 'cancelled') },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/FlightStatusBadge:cancelled', defaultMessage: 'Cancelled' })));
        }
        if (flightStatus === 'closed') {
            return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(itemClassName, 'closed') },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/FlightStatusBadge:closed', defaultMessage: 'Closed' })));
        }
        if (flightStatus === 'departed') {
            return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(itemClassName, 'departed') },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/FlightStatusBadge:departed', defaultMessage: 'Departed' })));
        }
        return null;
    };
    const getDeactivatedBadge = () => {
        if (!isDeactivated)
            return null;
        return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(itemClassName, 'deactivated') },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/FlightStatusBadge:deactivated', defaultMessage: 'Deactivated' })));
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__items` },
            getBookedOutBadge(),
            getStatusBadge(),
            getDeactivatedBadge())));
};
exports.FlightStatusBadge = FlightStatusBadge;
//# sourceMappingURL=index.js.map